import { render, staticRenderFns } from "./PreviewExcel.vue?vue&type=template&id=2ffe921c&scoped=true&"
import script from "./PreviewExcel.vue?vue&type=script&lang=js&"
export * from "./PreviewExcel.vue?vue&type=script&lang=js&"
import style0 from "./PreviewExcel.vue?vue&type=style&index=0&id=2ffe921c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffe921c",
  null
  
)

export default component.exports